/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { District } from '../../models/district';

export interface ApiMasterProvinceGetDistrictByIdGet$Params {
  id?: number;
}

export function apiMasterProvinceGetDistrictByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterProvinceGetDistrictByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<District>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterProvinceGetDistrictByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<District>>;
    })
  );
}

apiMasterProvinceGetDistrictByIdGet.PATH = '/api/Master/Province/GetDistrictById';
